"use client";

import { motion } from "motion/react";
import { useEntranceStill } from "./useEntranceStill";

/**
 * Scroll-triggered entrance wrapper. Fades children in and lifts them slightly
 * as they enter the viewport. Animates once and accepts a delay for staggering
 * sibling reveals. SSR/no-JS/reduced-motion rendering follows the
 * useEntranceStill contract: while the gate is closed, children render bare
 * and fully visible.
 */
export function Reveal({
  children,
  delay = 0,
  y = 24,
}: {
  children: React.ReactNode;
  delay?: number;
  y?: number;
}) {
  const still = useEntranceStill();

  if (still) {
    return <>{children}</>;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -80px 0px" }}
      transition={{ duration: 0.6, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    >
      {children}
    </motion.div>
  );
}
